export { BrandPattern } from "@/components/ui/BrandPattern";
